export { default } from './BaseChartBar';
